import React, { useState, useEffect } from 'react';

const heroStyles = {
  wrap: { position: 'relative', overflow: 'hidden', background: 'var(--bg)', borderBottom: '1px solid var(--border)' },
  dotgrid: {
    position: 'absolute', inset: 0,
    backgroundImage: 'radial-gradient(circle, #D4D4D4 1px, transparent 1px)',
    backgroundSize: '24px 24px',
    maskImage: 'radial-gradient(ellipse at center, black 30%, transparent 75%)',
    WebkitMaskImage: 'radial-gradient(ellipse at center, black 30%, transparent 75%)',
    opacity: 0.6,
    pointerEvents: 'none',
  },
  inner: { position: 'relative', maxWidth: 1280, margin: '0 auto', padding: '120px 32px 96px', textAlign: 'center' },
  overline: {
    fontFamily: 'var(--font-mono)', fontSize: 11, letterSpacing: '0.18em',
    textTransform: 'uppercase', color: 'var(--fg-muted)', marginBottom: 32,
  },
  head: {
    fontFamily: 'var(--font-display)', fontWeight: 400,
    fontSize: 'clamp(64px, 9vw, 128px)',
    lineHeight: 0.95, letterSpacing: '-0.04em',
    margin: 0, color: 'var(--fg)',
  },
  dot: {
    display: 'inline-block', width: '0.18em', height: '0.18em',
    borderRadius: '50%', background: 'var(--accent)',
    verticalAlign: 'baseline', marginLeft: '0.04em',
    boxShadow: '0 0 0 0 #FF4D0066', animation: 'unc-pulse 2.4s infinite ease-in-out',
  },
  lede: {
    fontFamily: 'var(--font-sans)', fontSize: 19, lineHeight: 1.6,
    color: 'var(--fg-muted)', maxWidth: 540, margin: '32px auto 0',
  },
};

const btnStyles = {
  primary: {
    fontFamily: 'var(--font-sans)', fontSize: 15, fontWeight: 500,
    padding: '14px 22px', borderRadius: 10, border: 'none',
    background: '#FF4D00', color: '#fff', cursor: 'pointer',
    transition: 'background 140ms var(--ease-out)',
  },
  ghost: {
    fontFamily: 'var(--font-sans)', fontSize: 15, fontWeight: 500,
    padding: '14px 22px', borderRadius: 10,
    background: 'transparent', color: 'var(--fg)', cursor: 'pointer',
    border: '1px solid var(--border)',
    transition: 'border-color 140ms var(--ease-out), background 140ms var(--ease-out)',
  },
};

export { btnStyles };

export default function Hero({ onNavigate }) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => { setTimeout(() => setMounted(true), 50); }, []);

  const words = ['Made', 'on', 'purpose.'];
  return (
    <section style={heroStyles.wrap}>
      <div style={heroStyles.dotgrid} />
      <div style={heroStyles.inner}>
        <div style={heroStyles.overline}>The UNC · est. 2024</div>
        <h1 style={heroStyles.head}>
          {words.map((w, i) => (
            <span key={i} style={{
              display: 'inline-block',
              opacity: mounted ? 1 : 0,
              transform: mounted ? 'translateY(0)' : 'translateY(24px)',
              transition: `opacity 0.7s var(--ease-out) ${i * 0.12}s, transform 0.7s var(--ease-out) ${i * 0.12}s`,
              fontStyle: i === 1 ? 'italic' : 'normal',
              marginRight: '0.25em',
            }}>{w}{i === 2 && <span style={heroStyles.dot} />}</span>
          ))}
        </h1>
        <p style={{
          ...heroStyles.lede,
          opacity: mounted ? 1 : 0,
          transform: mounted ? 'translateY(0)' : 'translateY(12px)',
          transition: 'opacity 0.7s var(--ease-out) 0.5s, transform 0.7s var(--ease-out) 0.5s',
        }}>
          A small studio. A handful of apps. Each one made with care, by people who use them every day.
        </p>
        <div style={{
          display: 'flex', gap: 12, marginTop: 32, justifyContent: 'center',
          opacity: mounted ? 1 : 0, transform: mounted ? 'translateY(0)' : 'translateY(12px)',
          transition: 'opacity 0.7s var(--ease-out) 0.7s, transform 0.7s var(--ease-out) 0.7s',
        }}>
          <button onClick={() => document.getElementById('portfolio')?.scrollIntoView({ behavior: 'smooth' })} style={btnStyles.primary}>
            View portfolio <span style={{ marginLeft: 6 }}>→</span>
          </button>
          <button onClick={() => onNavigate('studio')} style={btnStyles.ghost}>
            About the studio
          </button>
        </div>
      </div>
    </section>
  );
}
